module.exports = __webpack_public_path__ + "img/Logo_gray@3x.e0f1ace0.png";